import React from "react";
import { useImmer } from "use-immer";

import { useInterval } from "@intelligems/ig-utils";
import { Campaign } from "@mui/icons-material";
import { ListItemButton, ListItemText } from "@mui/material";

import "./NavBar.css";

// Butterflye Code
const butterflyeRoot = "https://app.butterflye.io";
const butterflyeSrc = butterflyeRoot + "/assets/sdk/v1/";

export const AnnouncementButton = () => {
  const [bfInit, setBfInit] = useImmer<boolean>(false);
  const PREFIX = "SideNavBarFooter";
  const classes = {
    selected: `${PREFIX}-selected`,
    root: `${PREFIX}-root`,
    selectedCollapse: `${PREFIX}-selectedCollapse`,
    rootCollapse: `${PREFIX}-rootCollapse`,
    buttonContainer: `${PREFIX}-buttonContainer`,
  };

  useInterval(
    () => {
      // @ts-ignore
      const bf = window.butterflye;
      if (!bfInit && bf) {
        bf.init([bf.WIDGETS.CHANNEL_DRAWER], ({ channelDrawer }) => {
          channelDrawer.event("init", {
            workspace: "intelligems",
            channel: "intelligems-announcements",
            feed_slug: "feed",
            roadmap_slug: "roadmap",
            idea_slug: "idea-showcase",
            root: butterflyeRoot,
            src: butterflyeSrc,
            triggerId: "bf-toggle-drawer",
          });
        });
        setBfInit(true);
      }
    },
    bfInit ? null : 10
  );

  return (
    <ListItemButton
      aria-label="announcements"
      classes={{ selected: classes.selected, root: classes.root }}
    >
      <div className={classes.buttonContainer} id="bf-toggle-drawer">
        <Campaign />
        <ListItemText
          disableTypography={true}
          sx={{
            marginLeft: "15px",
            fontSize: "14px",
          }}
          primary={"What's New"}
        />
      </div>
    </ListItemButton>
  );
};
